import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type ChatInactiveIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function ChatInactiveIcon({
  className,
  pathClassName = "stroke-white",
  ...props
}: ChatInactiveIconProps) {
  return (
    <Svg
      width={29}
      height={29}
      viewBox="0 0 29 29"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M25.292 14.5a10.763 10.763 0 01-3.155 7.63 10.794 10.794 0 01-7.636 3.162 10.72 10.72 0 01-4.428-.946l-4.512.668a1.395 1.395 0 01-1.568-.998 1.389 1.389 0 01-.02-.671L4.6 18.77a10.433 10.433 0 01-.89-4.27 10.766 10.766 0 013.155-7.63 10.793 10.793 0 017.636-3.162 10.804 10.804 0 017.636 3.162 10.774 10.774 0 013.155 7.63z"
        className={pathClassName}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export default ChatInactiveIcon;
